export default {
  textClipInit: function (el) {
    el.style['text-overflow'] = 'ellipsis'
    el.style['overflow'] = 'hidden'
    el.style['white-space'] = 'nowrap'
  },
  textClipInitPre: function (el) {
    el.style['text-overflow'] = 'ellipsis'
    el.style['overflow'] = 'hidden'
    el.style['white-space'] = 'pre'
  },
  widthInitUserGame: function (el, binding) {
    if (binding.value > 0) {
      let containerWidth = el.clientWidth
      let padding = 96
      let listWidth = binding.value * 48 + (binding.value - 1) * 6
      let itemWidth = containerWidth - padding - listWidth
      let item = document.getElementsByClassName('pir_main')[0]
      if (item !== undefined) {
        item.style.width = itemWidth + 'px'
      }
    }
  },
  widthInitReserve: function (el) {
    let containerWidth = el.clientWidth
    let padding = 28 + 24 + 6 + 8 + window.innerWidth * 0.3
    let titleWidth = document.getElementsByClassName('dm_name')[0].clientWidth
    let itemWidth = containerWidth - padding - titleWidth
    let itemCurrentWidth = document.getElementsByClassName('dm_gname')[0].clientWidth
    if (itemCurrentWidth > itemWidth) {
      document.getElementsByClassName('dm_gname')[0].style.width = itemWidth + 'px'
    }
  },
  widthInitUserRecent: function (el) {
    let containerWidth = el.clientWidth
    let padding = 28 + 24 + 6 + 8 + window.innerWidth * 0.3
    let titleWidth = document.getElementsByClassName('userRecentTitle')[0].clientWidth + 30
    let itemWidth = containerWidth - padding - titleWidth
    let itemCurrentWidth = document.getElementsByClassName('userRecent')[0] ? document.getElementsByClassName('userRecent')[0].clientWidth : 0
    if (itemCurrentWidth > itemWidth) {
      document.getElementsByClassName('userRecent')[0].style.width = itemWidth + 'px'
    }
  },
  removePx: function (str) {
    return str.slice(0, str.indexOf('px'))
  },
  initPageHeight: function (el) {
    let contentHeight = document.getElementsByClassName('p_cont')[0].offsetHeight
    let windowHeight = window.innerHeight
    if (contentHeight < windowHeight) {
      el.style.height = windowHeight + 'px'
    } else {
      el.style.height = 'auto'
    }
  },
  listWidthInit: function (el) {
    if (el.childNodes.length > 0) {
      let itemNum = 0
      let items = el.childNodes
      for (let i = 0; i < items.length; i++) {
        if (items[i].childNodes.length > 0) {
          items[i].style.display = 'list-item'
          itemNum++
        }
      }

      let item = el.childNodes[0]
      let style = item.currentStyle || window.getComputedStyle(item)
      let marginLeftStr = style['margin-left']
      let marginRightStr = style['margin-right']
      let marginLeft = Math.ceil(marginLeftStr.slice(0, marginLeftStr.indexOf('px')))
      let marginRight = Math.ceil(marginRightStr.slice(0, marginRightStr.indexOf('px')))
      let outerWidth = item.offsetWidth + marginLeft + marginRight

      el.style.width = (outerWidth + 1) * itemNum + 'px'
    }
  },
  modalShow: function (el, binding) {
    let mask = el.childNodes[0]
    let wrap = el.childNodes[2]

    if (binding.value === true) {
      mask.style.display = 'block'
      document.body.style.top = '-' + document.body.scrollTop + 'px'
      if (document.body.className.indexOf('M_open') === -1) {
        document.body.className += ' M_open'
      }
      wrap.style.display = 'block'
      let marginTop = window.getComputedStyle(wrap).getPropertyValue('margin-top').replace('px', '')
      marginTop = marginTop === 'undefined' ? 0 : marginTop
      let marginBottom = window.getComputedStyle(wrap).getPropertyValue('margin-bottom').replace('px', '')
      marginBottom = marginBottom === 'undefined' ? 0 : marginBottom
      console.log('调试高度：')
      console.log(window.outerHeight)
      console.log(wrap.offsetHeight)
      console.log(marginTop)
      console.log(marginBottom)
      wrap.style.top = (window.outerHeight - wrap.offsetHeight - marginTop - marginBottom) / 2 + 'px'
    }
  },
  modalHide: function (el) {
    let mask = el.childNodes[0]
    let wrap = el.childNodes[2]
    let top = parseInt(document.body.style.top.replace('-', '').replace('px', ''))
    document.body.className = document.body.className.replace(/ M_open/g, '')
    mask.style.display = 'none'
    wrap.style.display = 'none'
    window.scroll(0, top)
  },
  toastShow: function (el, binding) {
    let wrap = el.childNodes[2]
    if (binding.value === true) {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      document.body.style.top = '-' + scrollTop + 'px'
      if (document.body.className.indexOf('T_open') === -1) {
        document.body.className += ' T_open'
      }
      wrap.style.display = 'block'
      wrap.style.top = (window.innerHeight - wrap.offsetHeight) / 2 + 'px'
    }
  },
  toastHide: function (el) {
    let wrap = el.childNodes[2]
    let top = parseInt(document.body.style.top.replace('-', '').replace('px', ''))
    document.body.className = document.body.className.replace(/ T_open/g, '')
    wrap.style.display = 'none'
    window.scroll(0, top)
  }
}



// WEBPACK FOOTER //
// ./src/v2/static/js/initStyle.js